import { Component } from '@angular/core';
import { ButtonIconSet } from 'src/app/common-components/buttons/buttons.types';
import {
  MunilyIconButtonColor,
  MunilyIconButtonSize,
  MunilyIconButtonVariant,
} from 'src/app/common-components/buttons/icon-button/icon-button.types';

@Component({
  selector: 'app-icon-button-playground',
  templateUrl: './icon-button-playground.component.html',
  styleUrls: ['./icon-button-playground.component.scss'],
})
export class IconButtonPlaygroundComponent {
  // ── Controles interactivos ────────────────────────────────────────────────
  icon = 'edit';
  iconSet: ButtonIconSet = 'material-symbols-rounded';
  ariaLabel = 'Icon button';

  variant: MunilyIconButtonVariant = 'default';
  color: MunilyIconButtonColor = 'primary';
  size: MunilyIconButtonSize = 'small';

  disabled = false;
  loading = false;
  iconFill = false;
  backgroundOpacity: number | null = null;

  // plain-specific
  iconPadding = 0;

  lastEvent = '';

  // ── Catálogo estático ────────────────────────────────────────────────────
  readonly variants: MunilyIconButtonVariant[] = ['default', 'plain'];
  readonly colors: MunilyIconButtonColor[] = ['primary', 'secondary', 'warning', 'weak'];
  readonly sizes: MunilyIconButtonSize[] = ['small', 'medium', 'large'];
  readonly iconSets: ButtonIconSet[] = ['material-symbols-rounded', 'material-icons', 'material-icons-outlined'];

  readonly plainPaddingSamples = [
    { label: 'sin padding (24×24)', padding: 0, opacity: null },
    { label: 'padding 4px', padding: 4, opacity: null },
    { label: 'padding 8px + fondo 10%', padding: 8, opacity: 0.1 },
    { label: 'padding 8px + fondo 20%', padding: 8, opacity: 0.2 },
  ];

  get isPlain(): boolean {
    return this.variant === 'plain';
  }

  onClick(): void {
    this.lastEvent = `output @ ${new Date().toLocaleTimeString()}`;
  }
}

